import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterVisible',
  pure: false,
  standalone: true
})
export class FilterVisiblePipe implements PipeTransform {
  transform(items: any[]): any {
    if (!items) {
      return items;
    }
    return items.filter(item => this.isVisible(item));
  }

  isVisible(item) {
    if (item != null) {
      if (this.hasProp(item, 'isVisible')) {
        return item.isVisible;
      } else if (item.packageDetails != null && this.hasProp(item.packageDetails, 'isVisible')) {
        return item.packageDetails.isVisible;
      } else {
        return true;
      }
    }
    return false;
  }

  hasProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
}
